{
    "image_upload_error": "Failed to upload the image. Try reloading this page and selecting an image again.",
    "search_placeholder": "Search photos and illustrations",
    "search": "Find",
    "photo": "Image",
    "image_by": "by",
    "free_photos_from": "Free stock images from",
    "uploading": "Uploading",
    "cancel": "Cancel",
    "select": "Select"
}
